module.exports = __webpack_public_path__ + "static/media/GD.8f8cb3d1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/GD.svg
// module id = 257
// module chunks = 0